// extracted by mini-css-extract-plugin
export default {"contents":"HF-z","sectionHeading":"IF-z"};